/**
 * field-notes-media.js
 * Rival Bros - Field Notes article body media.
 *
 * Two jobs, both scoped to .article-template--field-notes .rte only:
 *
 * 1. Resolution repair. Images inserted through the Shopify rich text editor
 *    at a fixed size carry a baked-in derivative suffix (Photo_600x600.png).
 *    That file IS the downsample, so the detail is already gone before the
 *    browser sees it. This script recovers the master URL by removing the
 *    suffix, then serves a responsive srcset sized to the 720px reading
 *    column. Shopify never upscales past the original, so a small master is
 *    returned unchanged rather than stretched.
 *
 * 2. Full resolution view. Each repaired photo is wrapped in an anchor to the
 *    master file and opened in the theme's modal-dialog element. With
 *    JavaScript off, or before this script runs, the anchor still works as a
 *    plain link to the full size image.
 *
 * Images with no derivative suffix (logos, lockups, badges) are left alone.
 * Images already inside a link are left alone.
 *
 * Vignovic Agency - Rival Bros Field Notes (EO run RB-FN1)
 */
(function () {
  'use strict';

  var SCOPE_SELECTOR = '.article-template--field-notes .rte';
  var SIZE_SUFFIX = /_\d+x\d*(?=\.(?:png|jpe?g|gif|webp|avif)(?:$|\?))/i;
  var SRCSET_WIDTHS = [750, 1100, 1500, 2000];
  var SIZES_ATTR = '(min-width: 750px) 720px, 100vw';
  var MODAL_ID = 'FieldNotesMediaModal';

  function isShopifyCdn(src) {
    return src.indexOf('cdn.shopify.com') !== -1 || src.indexOf('/cdn/shop/') !== -1;
  }

  function withWidth(url, width) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function isFloated(img) {
    var FLOATED = /float\s*:\s*(left|right)/i;
    if (FLOATED.test(img.getAttribute('style') || '')) return true;
    var parent = img.parentElement;
    return !!parent && FLOATED.test(parent.getAttribute('style') || '');
  }

  function repair(img, index) {
    var src = img.getAttribute('src') || '';

    if (!src || img.getAttribute('data-fn-repaired')) return;
    if (!isShopifyCdn(src) || !SIZE_SUFFIX.test(src)) return;
    if (isFloated(img)) return;
    if (img.closest('a')) return;

    var master = src.replace(SIZE_SUFFIX, '');
    var srcset = SRCSET_WIDTHS.map(function (width) {
      return withWidth(master, width) + ' ' + width + 'w';
    }).join(', ');

    img.setAttribute('data-fn-repaired', 'true');
    img.setAttribute('data-fn-fallback', src);

    img.addEventListener('error', function onError() {
      img.removeEventListener('error', onError);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', src);
      var wrapper = img.closest('.field-notes-photo-link');
      if (wrapper) wrapper.setAttribute('href', src);
    });

    img.setAttribute('srcset', srcset);
    img.setAttribute('sizes', SIZES_ATTR);
    img.setAttribute('src', withWidth(master, 1500));
    img.setAttribute('decoding', 'async');
    img.setAttribute('loading', index === 0 ? 'eager' : 'lazy');
    img.classList.add('field-notes-photo');

    wrap(img, master);
  }

  function wrap(img, master) {
    var modal = document.getElementById(MODAL_ID);
    var label = modal ? modal.getAttribute('data-open-label') : null;
    var link = document.createElement('a');

    link.className = 'field-notes-photo-link';
    link.setAttribute('href', master);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
    link.setAttribute('aria-label', img.getAttribute('alt') || label || 'View this photo at full size');

    img.parentNode.insertBefore(link, img);
    link.appendChild(img);
  }

  function openModal(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!event.target || !event.target.closest) return;

    var link = event.target.closest('.field-notes-photo-link');
    if (!link) return;

    var modal = document.getElementById(MODAL_ID);
    if (!modal || typeof modal.show !== 'function') return;

    var image = modal.querySelector('.field-notes-modal__image');
    if (!image) return;

    event.preventDefault();

    var source = link.getAttribute('href');
    var inner = link.querySelector('img');

    image.setAttribute('src', source);
    image.setAttribute('alt', (inner && inner.getAttribute('alt')) || '');
    modal.show(link);
  }

  function bindModalDismiss() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    var dialog = modal.querySelector('.field-notes-modal__dialog');
    if (!dialog) return;

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog && typeof modal.hide === 'function') modal.hide();
    });
  }

  function init() {
    var scope = document.querySelector(SCOPE_SELECTOR);
    if (!scope) return;

    var images = scope.querySelectorAll('img');
    for (var i = 0; i < images.length; i++) {
      repair(images[i], i);
    }

    bindModalDismiss();
    document.addEventListener('click', openModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();